import React from 'react';
import { useIntl } from 'react-intl';

import ActionButton from 'components/widgets/ActionButton/ActionButton';
import { useParentalControlContext } from 'context/parentalControlContext/parentalControlContext';

import { FULL_COMPONENT_NAME, typePin } from '../../constans';
import AgeRanges from '../AgeRanges/AgeRanges';
import ParentalInfo from '../ParentalInfo/ParentalInfo';

import styles from './ParentalBlock.module.scss';

const ParentalBlock = () => {
  const { onChangePin } = useParentalControlContext();
  const intl = useIntl();
  const nameLabel = intl.formatMessage({ id: `${FULL_COMPONENT_NAME}.textRestriction`, defaultMessage: 'Viewing Restriction' });
  const buttonLabel = intl.formatMessage({ id: `${FULL_COMPONENT_NAME}.buttonChangeParental`, defaultMessage: 'Change Parental PIN' });

  return (
    <>
      <p className={styles.name}>{ nameLabel }</p>
      <div className={styles.block}>
        <ParentalInfo />
        <AgeRanges />
        <ActionButton title={buttonLabel} onClick={onChangePin(typePin.parental)} />
      </div>
    </>
  );
};

export default React.memo(ParentalBlock);
